<fe-header></fe-header>
<fe-href-subheader [breadcrumbs]="breadcrumbs"></fe-href-subheader>

<section class="view__cancel__reservation__top">
    <div
        class="view__cancel__reservation__top__content container d-flex align-items-center px-0"
    >
        <h2 class="view__cancel__reservation__top__content__title">
            {{
                'fe_viewcancel_viewcancel_view_cancel_reservation_top_title'
                    | translate
            }}
        </h2>
    </div>
</section>

<section
    class="view__cancel__reservation__bottom d-none d-lmd-flex mb-26 mb-sm-20"
>
    <div class="view__cancel__reservation__bottom__content container">
        <div class="row">
            <div
                class="col-6 view__cancel__reservation__bottom__content__left d-flex flex-column"
            >
                <span
                    class="view__cancel__reservation__bottom__content__left__indicates py-4"
                >
                    {{
                        'fe_viewcancel_viewcancel_view_cancel_reservation_bottom_left_indicates'
                            | translate
                    }}
                </span>
                <form
                    [formGroup]="cancelReservationForm"
                    (ngSubmit)="onSubmit()"
                >
                    <div
                        class="row gx-3 view__cancel__reservation__bottom__content__left__middle py-2"
                    >
                        <div class="col-12">
                            <fe-input
                                class="mb-2"
                                [id]="'lastName'"
                                [label]="
                                    'fe_viewcancel_viewcancel_view_cancel_reservation_bottom_left_first_input'
                                        | translate
                                "
                                [tabIndex]="'1001'"
                                formControlName="lastName"
                                [(ngModel)]="lastName"
                            ></fe-input>
                        </div>
                        <div class="row gx-3 pe-0">
                            <div class="col-custom-9-5">
                                <fe-input
                                    class=""
                                    [id]="'reservationKey'"
                                    [label]="
                                        'fe_viewcancel_viewcancel_view_cancel_reservation_bottom_left_second_input'
                                            | translate
                                    "
                                    [tabIndex]="'1002'"
                                    formControlName="reservationKey"
                                    [(ngModel)]="reservationKey"
                                ></fe-input>
                            </div>
                            <div class="col-custom-2-5 gx-0">
                                <fe-button
                                    class="d-grid btn-search-reservation h-100 fe-button"
                                    [btnClass]="
                                        'd-flex justify-content-center align-items-center p-0 h-100'
                                    "
                                    [style]="'primary'"
                                    [type]="'submit'"
                                    [tabIndex]="'1003'"
                                    [loading]="loadingBtn"
                                >
                                    {{
                                        'fe_viewcancel_viewcancel_view_cancel_reservation_bottom_left_button'
                                            | translate
                                    }}
                                </fe-button>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="py-4">
                    <svg
                        class="svg"
                        xmlns="http://www.w3.org/2000/svg"
                        width="25.142"
                        height="24.581"
                        viewBox="0 0 25.142 24.581"
                    >
                        <path
                            id="question"
                            d="M24.44,0H.6A.646.646,0,0,0,0,.6V24.04c0,.6.7.7,1.1.3l5.609-5.709a.759.759,0,0,1,.4-.2H24.541a.646.646,0,0,0,.6-.6V.6A.859.859,0,0,0,24.44,0ZM12.521,14.424h0a1,1,0,1,1,0-2,1.077,1.077,0,0,1,1,1A.946.946,0,0,1,12.521,14.424Zm1.8-4.608c-.1.1-.2.1-.3.2a.724.724,0,0,0-.4.6,1.2,1.2,0,0,1-1.2,1.1,1.122,1.122,0,0,1-1.2-1v-.1a3.09,3.09,0,0,1,1.7-2.5,1.061,1.061,0,0,0,.6-1.1,1.087,1.087,0,0,0-.8-.8.779.779,0,0,0-.8.2.907.907,0,0,0-.3,1c0,.2,0,.4-.2.5a1.114,1.114,0,0,1-1.9-.7,3.2,3.2,0,0,1,1.1-2.4,3.228,3.228,0,0,1,2.5-.7A3.211,3.211,0,0,1,14.324,9.816Z"
                            fill="#ca93fe"
                        ></path>
                    </svg>
                    <a
                        [routerLink]="
                            'questions/car-rental-conditions-and-policies'
                                | formatUrl
                        "
                        class="view__cancel__reservation__bottom__content__left__href ms-2"
                        >{{
                            'fe_viewcancel_viewcancel_view_cancel_reservation_bottom_left_href'
                                | translate
                        }}
                    </a>
                </div>
            </div>
            <div
                class="col-6 view__cancel__reservation__bottom__content__right d-flex flex-row align-items-center"
            >
                <img
                    [src]="'images/car_lense.png' | cdn"
                    alt="Car lens"
                    class="view__cancel__reservation__bottom__content__right__img mx-lg-2 ms-lmd-0 me-lmd-2 px-lmd-0 px-lg-4"
                />
                <div class="d-flex flex-column">
                    <span
                        class="view__cancel__reservation__bottom__content__right__title"
                        >{{
                            'fe_viewcancel_viewcancel_view_cancel_reservation_bottom_right_title'
                                | translate
                        }}
                    </span>
                    <span
                        class="view__cancel__reservation__bottom__content__right__description"
                        >{{
                            'fe_viewcancel_viewcancel_view_cancel_reservation_bottom_right_description'
                                | translate
                        }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</section>

<section
    class="view__cancel__reservation__bottom d-lmd-none d-xs-flex mb-26 mb-sm-20"
>
    <div
        class="view__cancel__reservation__bottom__content container px-lmd-6 px-sm-8"
    >
        <div class="row">
            <div
                class="col-12 view__cancel__reservation__bottom__content__left d-flex flex-column"
            >
                <span
                    class="view__cancel__reservation__bottom__content__left__indicates pt-4 pb-2"
                    >{{
                        'fe_viewcancel_viewcancel_view_cancel_reservation_bottom_left_indicates'
                            | translate
                    }}
                </span>
                <form
                    [formGroup]="cancelReservationForm"
                    (ngSubmit)="onSubmit()"
                >
                    <div
                        class="row gx-3 view__cancel__reservation__bottom__content__left__middle py-2"
                    >
                        <div class="col-12">
                            <fe-input
                                class="mb-2"
                                [id]="'lastName'"
                                [label]="
                                    'fe_viewcancel_viewcancel_view_cancel_reservation_bottom_left_first_input'
                                        | translate
                                "
                                [tabIndex]="'1001'"
                                formControlName="lastName"
                                [(ngModel)]="lastName"
                            ></fe-input>
                        </div>
                        <div class="col-12">
                            <fe-input
                                class="mb-2"
                                [id]="'reservationKey'"
                                [label]="
                                    'fe_viewcancel_viewcancel_view_cancel_reservation_bottom_left_second_input'
                                        | translate
                                "
                                [tabIndex]="'1002'"
                                formControlName="reservationKey"
                                [(ngModel)]="reservationKey"
                            ></fe-input>
                        </div>
                        <div class="col-12">
                            <fe-button
                                class="d-grid btn-search-reservation h-100 fe-button"
                                [btnClass]="
                                    'd-flex justify-content-center align-items-center py-2 h-100'
                                "
                                [style]="'primary'"
                                [type]="'submit'"
                                [tabIndex]="'1003'"
                            >
                                {{
                                    'fe_viewcancel_viewcancel_view_cancel_reservation_bottom_left_button'
                                        | translate
                                }}
                            </fe-button>
                        </div>
                    </div>
                </form>
                <div class="py-4">
                    <svg
                        class="svg"
                        xmlns="http://www.w3.org/2000/svg"
                        width="25.142"
                        height="24.581"
                        viewBox="0 0 25.142 24.581"
                    >
                        <path
                            id="question"
                            d="M24.44,0H.6A.646.646,0,0,0,0,.6V24.04c0,.6.7.7,1.1.3l5.609-5.709a.759.759,0,0,1,.4-.2H24.541a.646.646,0,0,0,.6-.6V.6A.859.859,0,0,0,24.44,0ZM12.521,14.424h0a1,1,0,1,1,0-2,1.077,1.077,0,0,1,1,1A.946.946,0,0,1,12.521,14.424Zm1.8-4.608c-.1.1-.2.1-.3.2a.724.724,0,0,0-.4.6,1.2,1.2,0,0,1-1.2,1.1,1.122,1.122,0,0,1-1.2-1v-.1a3.09,3.09,0,0,1,1.7-2.5,1.061,1.061,0,0,0,.6-1.1,1.087,1.087,0,0,0-.8-.8.779.779,0,0,0-.8.2.907.907,0,0,0-.3,1c0,.2,0,.4-.2.5a1.114,1.114,0,0,1-1.9-.7,3.2,3.2,0,0,1,1.1-2.4,3.228,3.228,0,0,1,2.5-.7A3.211,3.211,0,0,1,14.324,9.816Z"
                            fill="#ca93fe"
                        ></path>
                    </svg>
                    <a
                        [routerLink]="
                            'questions/car-rental-conditions-and-policies'
                                | formatUrl
                        "
                        class="view__cancel__reservation__bottom__content__left__href ms-2"
                        >{{
                            'fe_viewcancel_viewcancel_view_cancel_reservation_bottom_left_href'
                                | translate
                        }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
<fe-footer></fe-footer>
